export default __webpack_public_path__ + "static/media/studentRealCase1.d085512f.png";